import { EditCommittee } from '@src/api';

import { ContactUI } from './contact.model';

export interface CommitteeUI extends EditCommittee {
  photo?: File;
  contacts?: ContactUI[];
  icon?: string;
  parentId?: string;
  children?: CommitteeUI[];
  subCommitties?: Array<CommitteeUI>;
  parentCommittees?: Array<CommitteeUI>;
  photoId?: string;
  usersCount?: number;
  parentOrganisationId?: string;
}

export interface CommitteeTreeItem {
  /** Идентификатор комитета */
  id?: string;

  /** Родительский комитет */
  parentId?: string;

  /** Наименование комитета */
  title?: string;

  /** Флаг, что данная запись является корнем */
  isRoot: boolean;
}
